import { render, staticRenderFns } from "./StaffCard.vue?vue&type=template&id=41b33b44&scoped=true"
import script from "./StaffCard.vue?vue&type=script&lang=js"
export * from "./StaffCard.vue?vue&type=script&lang=js"
import style0 from "./StaffCard.vue?vue&type=style&index=0&id=41b33b44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b33b44",
  null
  
)

export default component.exports